import { useCallback } from 'react';
import WaveSurfer from 'wavesurfer.js';
import { WaveSurferRef } from './types';

export const usePause = (waveSurferRef: WaveSurferRef): WaveSurfer['pause'] => {
  return useCallback(() => {
    waveSurferRef.current?.pause();
  }, [waveSurferRef]);
};
